export default {
  expenseDetail: {
    column: {
      projectName: '项目名称',
      periodName: '结算周期',
      expenseEntity: '费用主体',
      expenseType: '费用类别',
      expenseName: '费用名称',
      amountWithTax: '含税金额(元)',
      amountWithTaxTotal: '含税金额(元)小计',
      taxRate: '税率(%)',
      amountWithoutTax: '不含税金额(元)',
      amountWithoutTaxTotal: '不含税金额(元)小计',
      businessCompanyName: '公司',
      businessDepartmentName: '业务部门',
      businessUser: '业务员',
      createBy: '操作人',
      gmtCreate: '创建日期',
      gmtCreateStart: '创建日期从',
      gmtCreateEnd: '创建日期到',
      docNo: '费用明细编码',
    },
    placeholder: {
      expenseEntity: '请选择费用主体',
      expenseType: '请选择费用类别',
      amountWithTax: '请输入含税金额',
      taxRate: '请选择税率',
      auto: '自动生成',
    },
    collapseTitle: {
      basicTitle: '基本信息',
      detailTitle: '费用明细信息',
    },
  },
};
